angular.module('contabilidad.polizas')
  .service('ContabilidadPolizasProvisionnominaconpagos', ContabilidadPolizasProvisionnominaconpagos)

ContabilidadPolizasProvisionnominaconpagos.$inject = ['$http', '$filter']

function ContabilidadPolizasProvisionnominaconpagos ($http, $filter) {
  this.get = _get
  this.codificar = _codificar

  function _get (nominas) {
    return $http.get('/kendu/contabilidad/polizas/polizasprovisionnominaconpagos', {
      params: {nominas: nominas},
      schema: schema,
    }).then(function (response) {
      // if(response.data.pagos.length > 0){
      // 	var pagos = [];
      // 	response.data.provision.map(function(item){
      // 		item.pagos = response.data.pagos.filter(function(pago){
      // 			return item.id_empleado === pago.ID_Empleado;
      // 		});
      // 	});
      // 	// response.data.pagos = angular.copy(response.data.provision);
      // 	response.data.provision.forEach(function(item){
      // 		var pago = {},
      // 		importe_complementario = 0;
      // 		pago.provision = item.datos.filter(function (dato) {
      // 			return dato.concepto == "Provisión";
      // 		})[0];
      // 		if(item.pagos.length > 0 && item.pagos[0].Cuenta_Contable_Complementaria !== ''){
      // 			pago.Cuenta_Contable_Complementaria = item.pagos[0].Cuenta_Contable_Complementaria;
      // 			item.pagos.forEach(function(elemento){
      // 				importe_complementario += elemento.Importe;
      // 			});
      // 			pago.importe_complementario = pago.provision.importe - importe_complementario;
      // 		}
      // 		pago.pagos = item.pagos;
      // 		pago.banco = item.pagos[0]
      // 		if(item.pagos.length > 0)
      // 			pagos.push(pago);
      // 	});
      // 	response.data.pagos = pagos;
      // }
      return response
    })
  }

  var verificarCadena = $filter('rPad')

  function _codificar (data, inicio_poliza) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    3      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',
      fecha_inicio = new Date(),
      fechaA = $filter('date')(fecha_inicio, 'yyyyMMdd'),
      fechaB = $filter('date')(fecha_inicio, 'dd/MM/yyyy'),
      vuelta = 0,
      TotalAbonos = 0,
      posicion

    try {
      data.cuentascontables.forEach(function (item) {
        item.importe = 0
      })
      data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          posicion = data.cuentascontables.findIndex(function (cuenta) {
            return (cuenta.cuentacontable + cuenta.concepto) === (item.cuentacontable + item.concepto)
          })
          data.cuentascontables[posicion].importe += parseFloat(item.importe)
          fechaA = $filter('date')(nomina.fecha_nomina, 'yyyyMMdd')
        })
      })

      data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          if (vuelta === 0) {
            // fechaA = $filter("date")(empleado.fecha_nomina, "yyyyMMdd"),
            cadenaPrincipal += cadA
              .replace('AAAAMMDD', fechaA)
              .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('Provision Nomina' + ' ' + item.id_nomina, 60))
          }

          fechaB = verificarCadena(item.id_nomina, 15)
          if (Number.isFinite(item.importe) && item.importe !== 0) {
            cadenaPrincipal += cadB
              .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.cuentacontable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', fechaB)
              .replace('*', item.naturaleza === 'C' ? 0 : 1)
              .replace('YYYYYYYYY', verificarCadena((parseFloat(item.importe).toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.concepto), 43))
          }

          vuelta++
        })
      })

      data.pagos.forEach(function (item) {

        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 1)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        if (item.Importe_Complementario > 0) {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe_Complementario).toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        }
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Banco.replace(/-/g, '')), 16)
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 0)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Pago).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.Descripcion), 43))
      })
      return cadenaPrincipal

    } catch (err) { // try
      return 'Error'
    }

  }

  var schema = {
    provision: {datos: {importe: 'number'}},
    pagos: {Importe: 'number', Importe_Complementario: 'number'},
    cuentascontables: {importe: 'number'},
    poliza: 'number',
  }
}

// 2018-01-31
// (function (angular) {

//
// 	angular.module("contabilidad.polizas")
// 		.service("ContabilidadPolizasProvisionnominaconpagos", ContabilidadPolizasProvisionnominaconpagos);
//
// 	ContabilidadPolizasProvisionnominaconpagos.$inject = ["$http", "$filter"];
//
// 	function ContabilidadPolizasProvisionnominaconpagos($http, $filter) {
// 		this.get       = _get;
// 		this.codificar = _codificar;
//
// 		function _get(nominas) {
// 			return $http.get("/kendu/contabilidad/polizas/polizasprovisionnominaconpagos", {
// 				params: {nominas: nominas},
// 				schema: schema
// 			}).then(function (response) {
// 				// if(response.data.pagos.length > 0){
// 				// 	var pagos = [];
// 				// 	response.data.provision.map(function(item){
// 				// 		item.pagos = response.data.pagos.filter(function(pago){
// 				// 			return item.id_empleado === pago.ID_Empleado;
// 				// 		});
// 				// 	});
// 				// 	// response.data.pagos = angular.copy(response.data.provision);
// 				// 	response.data.provision.forEach(function(item){
// 				// 		var pago = {},
// 				// 		importe_complementario = 0;
// 				// 		pago.provision = item.datos.filter(function (dato) {
// 				// 			return dato.concepto == "Provisión";
// 				// 		})[0];
// 				// 		if(item.pagos.length > 0 && item.pagos[0].Cuenta_Contable_Complementaria !== ''){
// 				// 			pago.Cuenta_Contable_Complementaria = item.pagos[0].Cuenta_Contable_Complementaria;
// 				// 			item.pagos.forEach(function(elemento){
// 				// 				importe_complementario += elemento.Importe;
// 				// 			});
// 				// 			pago.importe_complementario = pago.provision.importe - importe_complementario;
// 				// 		}
// 				// 		pago.pagos = item.pagos;
// 				// 		pago.banco = item.pagos[0]
// 				// 		if(item.pagos.length > 0)
// 				// 			pagos.push(pago);
// 				// 	});
// 				// 	response.data.pagos = pagos;
// 				// }
// 				return response;
// 			});
// 		}
//
// 		var verificarCadena = $filter("rPad");
//
// 		function _codificar(data, inicio_poliza) {
// 			var cadenaPrincipal = "",
// 			    cadA            = "P  AAAAMMDD    3      JJJJ 1 0          " +
// 				    "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n",
// 			    cadB            = "M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0" +
// 				    "                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n",
// 			    fecha_inicio    = new Date(),
// 			    fechaA          = $filter("date")(fecha_inicio, "yyyyMMdd"),
// 			    fechaB          = $filter("date")(fecha_inicio, "dd/MM/yyyy"),
// 			    vuelta          = 0,
// 			    TotalAbonos     = 0,
// 			    posicion;
//
// 			try {
// 				data.cuentascontables.forEach(function (item) {
// 					item.importe = 0;
// 				});
// 				data.provision.forEach(function (empleado) {
// 					empleado.datos.forEach(function (item) {
// 						posicion = data.cuentascontables.findIndex(function (cuenta) {
// 							return (cuenta.cuentacontable + cuenta.concepto) === (item.cuentacontable + item.concepto);
// 						});
// 						data.cuentascontables[posicion].importe += parseFloat(item.importe);
// 						fechaA   = $filter("date")(empleado.fecha_nomina, "yyyyMMdd");
// 					});
// 				});
//
// 				data.cuentascontables.forEach(function (item) {
// 					if (vuelta === 0) {
// 						// fechaA = $filter("date")(empleado.fecha_nomina, "yyyyMMdd"),
// 						cadenaPrincipal += cadA
// 							.replace("AAAAMMDD", fechaA)
// 							.replace("JJJJ", ("000" + inicio_poliza).slice(-4))
// 							.replace("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX", verificarCadena('Provision Nomina' + ' ' + item.id_nomina, 60));
// 					}
//
// 					fechaB = verificarCadena(item.id_nomina, 15);
// 					if(item.importe > 0){
// 						cadenaPrincipal += cadB
// 							.replace("CCCCCCCCCCCCCCCC", verificarCadena(item.cuentacontable.replace(/-/g, ''), 16))
// 							.replace("ZZZZZZZZZZZZZZZ", fechaB)
// 							.replace("*", item.naturaleza === 'C' ? 0 : 1)
// 							.replace("YYYYYYYYY", verificarCadena(( parseFloat(Math.abs(item.importe)).toFixed(2) ), 9))
// 							.replace("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN", verificarCadena((item.concepto), 43));
// 					}
//
// 					vuelta++;
// 				});
//
// 				data.pagos.forEach(function (item) {
// 					item.pagos.forEach(function(pago){
// 					cadenaPrincipal += cadB
// 						.replace("CCCCCCCCCCCCCCCC", verificarCadena(pago.Cuenta_Contable.replace(/-/g, ''), 16))
// 						.replace("ZZZZZZZZZZZZZZZ", verificarCadena(pago.Fecha, 15))
// 						.replace("*", 1)
// 						.replace("YYYYYYYYY", verificarCadena((parseFloat(pago.Importe).toFixed(2)), 9))
// 						.replace("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN", verificarCadena((pago.ID_Nomina + " " + pago.Nombre_Empleado), 43));
// 					});
// 					if (item.Cuenta_Contable_Complementaria) {
// 						cadenaPrincipal += cadB
// 							.replace("CCCCCCCCCCCCCCCC", verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
// 							.replace("ZZZZZZZZZZZZZZZ", verificarCadena(item.banco.Fecha, 15))
// 							.replace("*", 1)
// 							.replace("YYYYYYYYY", verificarCadena((parseFloat(item.importe_complementario).toFixed(2)), 9))
// 							.replace("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN", verificarCadena((item.banco.ID_Nomina + " " + item.banco.Nombre_Empleado), 43));
// 					}
// 					cadenaPrincipal += cadB
// 						.replace("CCCCCCCCCCCCCCCC", verificarCadena(item.banco.Cuenta_Contable_Banco.replace(/-/g, '')), 16)
// 						.replace("ZZZZZZZZZZZZZZZ", verificarCadena(item.banco.Fecha, 15))
// 						.replace("*", 0)
// 						.replace("YYYYYYYYY", verificarCadena((parseFloat(item.banco.Moneda == 2 && item.banco.Tipo_Moneda == 2 ? item.provision.importe : item.banco.Importe).toFixed(2)), 9))
// 						.replace("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN", verificarCadena((item.banco.ID_Nomina + " " + item.banco.Descripcion), 43));
// 				});
// 				return cadenaPrincipal;
//
// 			} catch (err) { // try
// 				return "Error";
// 			}
//
// 		}
//
// 		var schema = {
// 			datos           : {importe: "number"},
// 			pagos           : {Importe: "number", ImporteUSD: "number"},
// 			cuentascontables: {importe: "number"},
// 			poliza          : "number"
// 		};
// 	}
// })(window.angular);



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/ContabilidadPolizasProvisionnominaconpagos.js